/**
 * DAYS THEME: Product View Toggle
 * Alterna entre view de info (nome + preço) e view de seleção (cores + tamanhos + add to cart)
 * Inspirado no design minimalista da Yeezy
 *
 * ABORDAGEM CSS GRID: CSS cuida de tudo (opacity, altura, sobreposição)
 * JavaScript apenas troca classes
 */

class DaysProductViewToggle {
  constructor() {
    this.infoView = document.querySelector('.product-view--info');
    this.selectionView = document.querySelector('.product-view--selection');
    this.openButton = this.infoView?.querySelector('.product-view-toggle');
    this.closeButton = this.selectionView?.querySelector('.product-view-toggle--close');

    this.init();
  }

  init() {
    // Verificar se os elementos existem
    if (!this.infoView || !this.selectionView) {
      console.warn('[Days Product Toggle] Views não encontradas');
      return;
    }

    // Garantir estado inicial correto
    this.infoView.classList.add('active');
    this.selectionView.classList.remove('active');

    // Event listeners
    this.openButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.showSelection();
    });

    this.closeButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.showInfo();
    });
  }

  showSelection() {
    // Prevenir múltiplos cliques durante transição
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    // Trocar classes - CSS cuida da transição
    this.infoView.classList.remove('active');
    this.selectionView.classList.add('active');

    // Liberar após duração da transição CSS (300ms)
    setTimeout(() => {
      this.isTransitioning = false;
    }, 300);
  }

  showInfo() {
    // Prevenir múltiplos cliques durante transição
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    // Trocar classes - CSS cuida da transição
    this.selectionView.classList.remove('active');
    this.infoView.classList.add('active');

    // Liberar após duração da transição CSS (300ms)
    setTimeout(() => {
      this.isTransitioning = false;
    }, 300);
  }
}

// Inicializar quando o DOM carregar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DaysProductViewToggle();
    // Marcar página como carregada para prevenir scroll inicial
    document.documentElement.classList.add('loaded');
    document.querySelector('.template-product')?.classList.add('loaded');
    document.querySelector('.product')?.classList.add('loaded');
  });
} else {
  new DaysProductViewToggle();
  // Marcar página como carregada para prevenir scroll inicial
  document.documentElement.classList.add('loaded');
  document.querySelector('.template-product')?.classList.add('loaded');
  document.querySelector('.product')?.classList.add('loaded');
}
